interface IIconProps {
    id?: string
    width?: string
    height?: string
    color?: string
    opacity?: string
}

interface IMenuIconProps {
    isOpen: boolean
}

// =====================================================


export const MenuIcon = ({ isOpen }: IMenuIconProps) => (
    <span className={`telegram-menu-icon${isOpen ? ' telegram-menu-icon--open' : ''}`} aria-hidden="true">
        <span className="telegram-menu-icon__line telegram-menu-icon__line--top" />
        <span className="telegram-menu-icon__line telegram-menu-icon__line--middle" />
        <span className="telegram-menu-icon__line telegram-menu-icon__line--bottom" />
    </span>
)


export const SearchIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <circle cx="11" cy="11" r="6" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20 20L15.4 15.4" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


export const FilterIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="M4 7H20" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 12H17" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 17H14" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


export const LogoutIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="M10 7V5.5C10 4.67157 10.6716 4 11.5 4H18.5C19.3284 4 20 4.67157 20 5.5V18.5C20 19.3284 19.3284 20 18.5 20H11.5C10.6716 20 10 19.3284 10 18.5V17" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 12H15" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.5 7.5L4 12L8.5 16.5" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


export const CloseIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="M7 7L17 17" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17 7L7 17" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


export const ArrowLeftIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="M15 5L8 12L15 19" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


export const MoreVerticalIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <circle cx="12" cy="5.5" r="1.5" fill={color} />
            <circle cx="12" cy="12" r="1.5" fill={color} />
            <circle cx="12" cy="18.5" r="1.5" fill={color} />
        </g>
    </svg>
)


export const SparkIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="M12 3L14.3 9.7L21 12L14.3 14.3L12 21L9.7 14.3L3 12L9.7 9.7L12 3Z" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


export const AttachmentIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="M8.5 12.5L14.8 6.2C16.4 4.6 19 4.6 20.6 6.2C22.1 7.8 22.1 10.4 20.6 12L11.5 21.1C8.9 23.7 4.7 23.7 2.1 21.1C-0.4 18.6 -0.4 14.4 2.1 11.8L11 2.9" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


export const DownloadIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="M12 4.5V14.5" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.5 11.5L12 15L15.5 11.5" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5 18.5H19" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


export const PlayIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="M8 6.5V17.5L17 12L8 6.5Z" fill={color} />
        </g>
    </svg>
)


export const PauseIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <rect x="7" y="6" width="3.5" height="12" rx="1.2" fill={color} />
            <rect x="13.5" y="6" width="3.5" height="12" rx="1.2" fill={color} />
        </g>
    </svg>
)


export const BellIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="M9.25 18H14.75" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.5 9.5C6.5 6.46243 8.96243 4 12 4C15.0376 4 17.5 6.46243 17.5 9.5V12.15C17.5 12.9357 17.776 13.6965 18.28 14.2991L19 15.16C19.7311 16.0341 19.1097 17.35 17.97 17.35H6.03C4.89029 17.35 4.26894 16.0341 5 15.16L5.72 14.2991C6.22402 13.6965 6.5 12.9357 6.5 12.15V9.5Z" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.15 18C10.3075 19.1315 11.28 20 12.45 20C13.62 20 14.5925 19.1315 14.75 18" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


export const PhoneCallIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="M19.5 16.2V17.2C19.5 18.47 18.47 19.5 17.2 19.5C10.19 19.5 4.5 13.81 4.5 6.8C4.5 5.53 5.53 4.5 6.8 4.5H7.8C8.45 4.5 9.01 4.93 9.18 5.55L9.88 8.1C10.03 8.65 9.89 9.23 9.51 9.65L8.42 10.86C9.53 13.08 10.92 14.47 13.14 15.58L14.35 14.49C14.77 14.11 15.35 13.97 15.9 14.12L18.45 14.82C19.07 14.99 19.5 15.55 19.5 16.2Z" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


export const ArchiveIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="M4 8.5C4 7.39543 4.89543 6.5 6 6.5H18C19.1046 6.5 20 7.39543 20 8.5V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V8.5Z" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3.5 5C3.5 3.89543 4.39543 3 5.5 3H18.5C19.6046 3 20.5 3.89543 20.5 5V6.5H3.5V5Z" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 12H15" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 15.5H14" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


export const TelegramSendIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="M20.8 4.6L17.4 20.3C17.1 21.7 16.1 22 14.9 21.3L9.8 17.6L7.3 20C7 20.3 6.7 20.6 6.1 20.6L6.5 15.3L16.2 6.5C16.6 6.1 16.1 5.9 15.5 6.2L3.5 13.8L-1.7 12.1C-2.8 11.8 -2.9 11 -1.5 10.5L18.4 2.8C19.7 2.3 21 3.1 20.8 4.6Z" transform="translate(2 0)" fill={color} />
        </g>
    </svg>
)


export const NotificationSuccessIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 12.5L10.75 15.25L16 10" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


export const NotificationErrorIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 8V12" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 16H12.01" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


export const NotificationInfoIcon = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 10V16" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12 7H12.01" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
)


/** Иконка - Удаление */
export const IconDelete = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <div style={{ width: width, height: height }}>
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity={opacity}>
                <path d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047" stroke={color} strokeOpacity="0.88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke={color} strokeOpacity="0.88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M18.85 9.13965L18.2 19.2096C18.09 20.7796 18 21.9996 15.21 21.9996H8.79002C6.00002 21.9996 5.91002 20.7796 5.80002 19.2096L5.15002 9.13965" stroke={color} strokeOpacity="0.88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10.33 16.5H13.66" stroke={color} strokeOpacity="0.88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9.5 12.5H14.5" stroke={color} strokeOpacity="0.88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
        </svg>
    </div>
)

/** Фильтр */
export const IconFilter = ({ id, width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <div id={id} style={{ width: width, height: height }}>
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity={opacity}>
                <path d="M14.3201 19.0698C14.3201 19.6798 13.92 20.4798 13.41 20.7898L12.0001 21.6998C10.6901 22.5098 8.87006 21.5998 8.87006 19.9798V14.6298C8.87006 13.9198 8.47006 13.0098 8.06006 12.5098L4.22003 8.46976C3.71003 7.95976 3.31006 7.05977 3.31006 6.44977V4.12976C3.31006 2.91976 4.22008 2.00977 5.33008 2.00977H18.67C19.78 2.00977 20.6901 2.91975 20.6901 4.02975V6.24976C20.6901 7.05976 20.1801 8.06976 19.6801 8.56976" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16.0701 16.52C17.8374 16.52 19.2701 15.0873 19.2701 13.32C19.2701 11.5527 17.8374 10.12 16.0701 10.12C14.3028 10.12 12.8701 11.5527 12.8701 13.32C12.8701 15.0873 14.3028 16.52 16.0701 16.52Z" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M19.8701 17.12L18.8701 16.12" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
        </svg>
    </div>
)

/** Настройки */
export const IconSettings = ({ id, width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <div id={id} style={{ width: width, height: height }}>
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity={opacity}>
                <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M2 12.8804V11.1204C2 10.0804 2.85 9.22043 3.9 9.22043C5.71 9.22043 6.45 7.94042 5.54 6.37042C5.02 5.47042 5.33 4.30042 6.24 3.78042L7.97 2.79042C8.76 2.32042 9.78 2.60042 10.25 3.39042L10.36 3.58042C11.26 5.15042 12.74 5.15042 13.65 3.58042L13.76 3.39042C14.23 2.60042 15.25 2.32042 16.04 2.79042L17.77 3.78042C18.68 4.30042 18.99 5.47042 18.47 6.37042C17.56 7.94042 18.3 9.22043 20.11 9.22043C21.15 9.22043 22.01 10.0704 22.01 11.1204V12.8804C22.01 13.9204 21.16 14.7804 20.11 14.7804C18.3 14.7804 17.56 16.0604 18.47 17.6304C18.99 18.5404 18.68 19.7004 17.77 20.2204L16.04 21.2104C15.25 21.6804 14.23 21.4004 13.76 20.6104L13.65 20.4204C12.75 18.8504 11.27 18.8504 10.36 20.4204L10.25 20.6104C9.78 21.4004 8.76 21.6804 7.97 21.2104L6.24 20.2204C5.33 19.7004 5.02 18.5304 5.54 17.6304C6.45 16.0604 5.71 14.7804 3.9 14.7804C2.85 14.7804 2 13.9204 2 12.8804Z" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    </div>
)

/** Двойная галочка */
export const IconDoneAll = ({ id, width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg id={id} width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="m18 7-1.41-1.41-6.34 6.34 1.41 1.41zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12zM.41 13.41 6 19l1.41-1.41L1.83 12z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
    </svg>
)

/** Выхода из приложения */
export const IconExitApp = ({ id, width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <div id={id} style={{ width: width, height: height }}>
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity={opacity}>
                <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 17L21 12L16 7" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M21 12H9" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    </div>
)

/** Варинаты ответов */
export const IconSmsTracking = ({ id, width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <svg id={id} width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g opacity={opacity}>
            <path d="M2 8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5H7" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2 16.5H8" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2 12.5H5" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
    </svg>
)

/** Иконка - Календарь */
export const IconCalendar = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <div style={{ width: width, height: height }}>
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity={opacity}>
                <path d="M8 2V5" stroke={color} strokeOpacity="0.88" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M16 2V5" stroke={color} strokeOpacity="0.88" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3.5 9.08984H20.5" stroke={color} strokeOpacity="0.88" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke={color} strokeOpacity="0.88" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.6947 13.7002H15.7037" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.6947 16.7002H15.7037" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.9955 13.7002H12.0045" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.9955 16.7002H12.0045" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.29431 13.7002H8.30329" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.29431 16.7002H8.30329" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    </div>
)

/** Иконка - Стрелка вниз */
export const IconArrowDown = ({ width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <div style={{ width: width, height: height }}>
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity={opacity}>
                <path d="M19.92 8.94995L13.4 15.47C12.63 16.24 11.37 16.24 10.6 15.47L4.07996 8.94995" stroke={color} strokeOpacity="0.88" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
        </svg>
    </div>
)

/** Вопрос */
export const IconQuestion = ({ id, width = '24px', height = '24px', color = 'currentColor', opacity }: IIconProps) => (
    <div id={id} style={{ width: width, height: height }}>
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity={opacity}>
                <path d="M17 18.4297H13L8.54999 21.3897C7.88999 21.8297 7 21.3598 7 20.5598V18.4297C4 18.4297 2 16.4297 2 13.4297V7.42969C2 4.42969 4 2.42969 7 2.42969H17C20 2.42969 22 4.42969 22 7.42969V13.4297C22 16.4297 20 18.4297 17 18.4297Z" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12.0001 11.3604V11.1504C12.0001 10.4704 12.4201 10.1104 12.8401 9.82037C13.2501 9.54037 13.66 9.18039 13.66 8.52039C13.66 7.60039 12.9201 6.86035 12.0001 6.86035C11.0801 6.86035 10.3401 7.60039 10.3401 8.52039" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M11.9955 13.75H12.0045" stroke={color} strokeOpacity="0.88" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
        </svg>
    </div>
)
